import { Component, OnInit } from '@angular/core';
import { SettingService } from './services/setting.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'app';
  constructor(private settingService: SettingService,) {
  }
  ngOnInit(): void {
    this.settingService.fetch();
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts